import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/router';
import { queryClient } from '@/services/queryClient';
import { useBrand } from '@/store/useBrand';
import { initTheme } from '@/store/useTheme';
import '@/styles/global.css';

// Aplica o tema persistido antes do primeiro render (evita flash de tema).
initTheme();
// Carrega a marca (white-label) e aplica em runtime. Fire-and-forget: o CSS
// já mostra a marca neutra (WIREDESK) até a resposta chegar — sem flash feio.
void useBrand.getState().loadBrand();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root element not found');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
